import { render, staticRenderFns } from "./DashboardQuoteStatus.vue?vue&type=template&id=8f6add50&scoped=true"
import script from "./DashboardQuoteStatus.vue?vue&type=script&lang=js"
export * from "./DashboardQuoteStatus.vue?vue&type=script&lang=js"
import style0 from "./DashboardQuoteStatus.vue?vue&type=style&index=0&id=8f6add50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6add50",
  null
  
)

export default component.exports